// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"user-frame_wrapper___dgMU","main":"user-frame_main__2IZLD"};